'use client';

import { useTranslations } from 'next-intl';
import { cn } from '@/lib/ui-kit/utils';

interface OutcomeTableHeaderProps {
  className?: string;
}

export const OutcomeTableHeader = ({ className }: OutcomeTableHeaderProps) => {
  const t = useTranslations('common');

  return (
    <div
      className={cn(
        'grid w-full border-b border-v2-border py-2 pr-4',
        'grid-cols-[minmax(200px,280px)_1fr_288px] items-center gap-4',
        'max-[700px]:grid-cols-[1fr_auto] max-[700px]:gap-2',
        className,
      )}
    >
      <div className="flex items-center">
        <span className="text-[12px] font-normal leading-4 tracking-[-0.12px] text-v2-text-secondary">
          {t('outcome')}
        </span>
      </div>

      <div className="flex items-center justify-center max-[700px]:justify-end">
        <span className="text-[12px] font-normal leading-4 tracking-[-0.12px] text-v2-text-secondary">
          {t('percentChance')}
        </span>
      </div>

      <div className="flex justify-end max-[700px]:hidden" />
    </div>
  );
};
